<template>
    <div class="cover flex-vc"
         style="background:url('https://assets.pfotoo.com/pcbg.jpg') center center / 100% 100% no-repeat #27c4a2;">
        <homeHeader hasNoTitle></homeHeader>
        <div class="cover-content flex-cm" style="padding-bottom: 20px;">
            <div class="fotoo-slogan-view">
                <div class="fotoo-slogan white-font">
                    <div style="font-size: 50px;">Fotoo征集一下</div>
                    <div style="font-size: 24px; margin-top: 30px;">征集征稿 丨 活动比赛 丨 大众投票评选 丨 评委打分评选 丨 收集文件…</div>
                    <div class="flex-lm" style="margin-top: 68px;">
                        <div class="flex-lt" style="align-items: flex-start;">
                            <div class="flex-lt" style="align-items: flex-start;">
                                <span class="font-size30">100</span>
                                <span class="font-size26" style="margin-left: 1px;margin-top: -6px;">+</span>
                            </div>
                            <span class="font-size16" style="margin-left: 5px;padding-top: 6px;">行业</span>
                        </div>
                        <div class="flex-lt" style="margin-left: 50px;">
                            <div class="flex-lt" style="align-items: flex-start;">
                                <span class="font-size30">{{numZJ}}</span>
                                <span class="font-size26" style="margin-left: 1px;margin-top: -6px;">+</span>
                            </div>
                            <span class="font-size16" style="margin-left: 5px;padding-top: 6px;">征集</span>
                        </div>
                        <div class="flex-lt" style="margin-left: 50px;">
                            <div class="flex-lt" style="align-items: flex-start;">
                                <span class="font-size30">{{numTG}}</span>
                                <span class="font-size26" style="margin-left: 1px;margin-top: -6px;">+</span>
                            </div>
                            <span class="font-size16" style="margin-left: 5px;padding-top: 6px;">投稿</span>
                        </div>
                    </div>
                </div>

                <div style="margin-top: 60px;margin-left: 30px; cursor: pointer;">
                    <el-popover
                            placement="right"
                            trigger="hover">
                        <el-image
                                style="width: 150px; height: 150px"
                                src="https://assets.pfotoo.com/qrcode.draft.png"
                                fit="cover"></el-image>
                        <a class="green-font font-size22"  slot="reference">免费使用 →</a>
                    </el-popover>
                    <el-popover
                            placement="right"
                            trigger="hover">
                        <el-image
                                style="width: 150px; height: 150px"
                                src="https://assets.pfotoo.com/qrcode.qy_draft.png"
                                fit="cover"></el-image>
                        <a class="green-font font-size22" style="margin-left: 100px;"  slot="reference">企业版 →</a>
                    </el-popover>
                    <a href="https://mp.weixin.qq.com/s/bxscAgasuDrtHsfi88EGSA" target="_blank"
                       class="green-font font-size22" style="margin-left: 100px; text-decoration: none;"   slot="reference">电脑创建活动 →</a>
                </div>
            </div>
            <div class="code-cover">
                <div class="fotoo-code flex-vc" :class="hasTestStyle()?'test-style':''">
                    <div class="code-top">欢迎登录PC后台</div>
                    <img v-if="codeurl" :src="codeurl" class="code" @error="retryimg"/>
                    <div class="code-info flex-vc">
                        <div>请使用微信扫描二维码登录</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="cover-footer">
            <div class="flex-lr white-font font-size20 footer-link" style="margin-bottom: 50px;padding: 0 130px; box-sizing: border-box;">
                <a href="https://support.qq.com/products/57964/" target="_blank">Fotoo用户交流</a>
                <a href="https://support.qq.com/products/57964/team/" target="_blank">Fotoo的故事</a>
                <el-popover
                        placement="right"
                        trigger="hover">
                    <el-image
                            style="width: 150px; height: 150px"
                            src="https://assets.pfotoo.com/images/wechat.qrcode.jpg"
                            fit="cover"></el-image>
                    <a slot="reference">微信公众号</a>
                </el-popover>
                <el-popover
                        placement="right"
                        trigger="hover">
                    <el-image
                            style="width: 150px; height: 150px"
                            src="https://assets.pfotoo.com/images/work/qycode.jpg"
                            fit="cover"></el-image>
                    <a slot="reference">联系我们</a>
                </el-popover>
            </div>
            <div class="font-size14 white-font flex-cm">西安空空如也网络科技有限公司 版权所有 <a
                    href="https://beian.miit.gov.cn/" style="color:#91ADE9;padding-left:10px;text-decoration: none;">陕ICP备18022589号-1</a>
            </div>
        </div>
    </div>
</template>

<script>
  import App from '../util/comfun'
  import homeHeader from '../pages/components/home/header.vue'
  export default {
    name: 'login',
    data() {
      return {
        code: '',
        codeurl: '',
        retryImgCount: 0,
        year: new Date().getFullYear(),
        numHY:100,
        numZJ:0,
        numTG:0,
      }
    },
    components:{
      homeHeader,
    },
    methods: {
      setNum(){
        let numTG=parseInt(new Date()/100)
        let f8=numTG.toString().substr(-7)
        let f1=parseInt(Math.random()*9)
        this.numTG=f8/1 + (f1>5?-1:1)*f1
        this.numZJ=parseInt(this.numTG/80)
      },
      async getlogincode() {
        //this.code='vking999'//App.mdx(navigator.userAgent);
        console.log({window,navigator})
        if(navigator.userAgent.indexOf('MicroMessenger')>-1){
          this.$message({
            showClose: false,
            message: '请复制链接在【电脑浏览器】中打开',
            type: 'error',
            duration:0,
          })
          return;
        }
        this.code = 'PC' + App.mdx(navigator.userAgent+Math.random());
        this.codeurl = await App.System.Qrcode({
          autoColor: false,
          inHyaline: false,
          lineColor: '0,0,0',
          page: 'pages/enter/enter',
          //scene:encodeURIComponent('code='+this.code),
          scene: 'code=' + this.code,
          width: 300,
          "showSplashAd": false,
        }, 'URL')
        this.init();
      },

      retryimg() {
        console.log('this.retryImgCount', this.retryImgCount)
        if (this.retryImgCount++ > 10) return;
        let img = event.srcElement;
        img.onerror = null; //防止闪图
        setTimeout(() => {
          img.src = this.codeurl + '&_t=' + Math.random();
        }, 500)
      },
      init() {
        if (!this.code) return;
        if(this.ws) return;
        this.ws = new WebSocket("wss://fotooapi.pfotoo.com/wss/webproxy/" + this.code);
        this.ws.onopen = (evt)=>{
          console.log("Connection open ...");
          if(this.connectSetInterval){
            clearInterval(this.connectSetInterval);
            this.connectSetInterval=null
          }
          this.intervalNum=0
          this.connectSetInterval=setInterval(()=>{
            if(this.intervalNum%3==0){
              if(this.ws && this.ws.readyState==1){
                let data={"identity":this.code.replace('PC','WX'),"params":{act:"connect"}}
                this.ws.send(JSON.stringify(data))
                console.log('this.connectSetInterval',this.ws.readyState,data)
              }
            }
            this.intervalNum++
            this.setNum()
          },1000)
        };
        this.ws.onmessage = (res)=>{
          let data = JSON.parse(res.data)
          console.log("Received Message: " + res.data);
          if(this.connectSetInterval){
            clearInterval(this.connectSetInterval)
          }
          if (data.openid && data.unionid) {
            localStorage.setItem('openid', data.openid)
            localStorage.setItem('unionid', data.unionid)
            localStorage.setItem('userinfo', data.userinfo)
            //跳转页面
            let params = {
              sourceType: 0,
              wechatUserInfo: {
                code: data.code,
              }
            }
            App.demand('/auth/login', 'POST', params).then((json) => {
              if (json.code == 200) {
                let data={"identity":this.code.replace('PC','WX'),"params":{act:"logined"}}
                this.ws.send(JSON.stringify(data))

                this.token = json.data.token;
                wxlite.setStorageSync('token', this.token);
                wxlite.setStorageSync('userId', json.data.userId);
                this.$router.replace('/home')
                this.ws.close()
                this.ws = null
              }else{
                let data={"identity":this.code.replace('PC','WX'),"params":{act:"fail"}}
                this.ws.send(JSON.stringify(data))
              }
            }).catch(()=>{
              let data={"identity":this.code.replace('PC','WX'),"params":{act:"fail"}}
              this.ws.send(JSON.stringify(data))
            })
          }
        };

        this.ws.onclose = (evt) => {
          console.log("Connection closed.",evt,this.ws);
          if (this.ws && this.ws.readyState == 3) {
            //this.ws.close()
            this.ws=null;
            setTimeout(()=>{this.init()},1000);
          }
        };
      },
      getauthcode(auth_code) {
        this.$http({
          url: 'https://pfotoo.com?s=App.Open.setAuth_code' + this.$getsign(),
          params: {
            auth_code: auth_code,
            openid: JSON.parse(localStorage.getItem('userinfo')).openid,
          },
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((res) => {
          console.log(res.body)
          let json = res.body;
          if (res.body.ret == 200) {
            console.log(json)
            this.$router.go(-3);
            // let wxlist=[];
            // wxlist.unshift(json.data);

          }
        })
      },
      hasTestStyle: App.hasTestStyle,
    },
    mounted() {
      this.getlogincode();
      // this.$router.replace('/home')
      wxlite.setStorageSync('messageNotice','')
    },
    destroyed(){
      if(this.ws){
        this.ws.close()
        this.ws = null
      }
      if(this.connectSetInterval){
        clearInterval(this.connectSetInterval)
        this.connectSetInterval=null
      }
    },
  }
</script>

<style>
    .cover {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
    }

    .cover-top {
        width: 100%;
        height: 64px;
        background: rgba(53, 53, 53, .6);
        padding: 0 30px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        margin: 0 auto;
    }

    .login-logo {
        width: 45px;
        height: 45px;
        margin-right: 16px;
    }

    .cover-content {
        width: 100%;
        padding: 0 100px;
        box-sizing: border-box;
    }

    .cover-footer {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        padding: 0 0 30px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        line-height: 1.2rem;
        text-align: center;
    }

    .fotoo-slogan {
        box-sizing: border-box;
        width: 100%;
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

        border-left: 5px solid #3DC4A7;
        padding-left: 25px;
        height: 255px;
    }
    .fotoo-slogan-view{
        width: calc(100% - 500px);
        max-width: 800px;
    }
    .code-cover {
        width: 500px;
        min-width: 500px;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        align-items: center;
        flex-direction: row;
    }

    .code-top {
        font-size: 24px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #ffffff;
        line-height: 33px;
    }

    .fotoo-code {
        width: 440px;
        height: 440px;
        background: rgba(255,255,255,0.15);
        border: 1px solid #ffffff;
        border-radius: 10px;
    }

    .code {
        width: 213px;
        height: 213px;
        background: #ffffff;
        border-radius: 10px;
        margin: 52px 0 30px;
    }

    .code-info {
        height: 25px;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        line-height: 25px;
    }

    .footer-link{
        max-width: 1450px;
        margin: 0 auto;
    }
    .footer-link a{
        text-decoration: none;
        color: #fefefe;
    }
    /*

    */
</style>



// WEBPACK FOOTER //
// src/components/login.vue